export const styles = (darkMode) => ({
    container: {
      maxWidth: 1400,
      margin: "0 auto",
      padding: "24px",
      backgroundColor: darkMode ? "#141414" : "#f0f2f5",
      minHeight: "100vh",
      transition: "all 0.3s ease",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 24,
    },
    headerTitle: {
      margin: 0,
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : "#1a1a1a",
    },
    headerActions: {
      display: "flex",
      gap: 16,
      alignItems: "center",
    },
    notificationBtn: {
      fontSize: 18,
      color: darkMode ? "rgba(255, 255, 255, 0.65)" : undefined,
    },
    welcomeCard: {
      borderRadius: 12,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
      backgroundImage: darkMode
        ? "linear-gradient(to right, #1f1f1f, #2a2a2a)"
        : "linear-gradient(to right, #f0f2f5, #e6f7ff)",
    },
    card: {
      borderRadius: 12,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    highlightCard: {
      backgroundColor: darkMode ? "#1890ff33" : "#e6f7ff",
      borderColor: darkMode ? "#1890ff66" : "#91d5ff",
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
  });